import { observer } from 'mobx-react-lite';

import {
  Dropdown,
  Form,
  Header,
  Icon,
  Input,
  Popup,
  Select,
} from 'semantic-ui-react';
import { barcodeOptions } from '../../../app/common/options/otherOptions/approveOptions';
import { useStore } from '../../../app/stores/store';
import { useEffect } from 'react';

const iconStyle = { marginTop: '15px' };

function SettingsBarcode() {
  const { workflowConfigurationStore, TemplateStore, metaDataStore } =
    useStore();
  const { selectedElement } = TemplateStore;
  const { selectedMetaDataElem } = metaDataStore;
  useEffect(() => {
    if (selectedElement && selectedElement.elementType === 'Barcode') {
      workflowConfigurationStore.setBarcodeType(
        selectedElement?.elementValue?.split('|')[1],
      );
      workflowConfigurationStore.setBarcodeValue0(
        selectedElement?.elementValue?.split('|')[0]?.split('-')[0],
      );
      workflowConfigurationStore.setBarcodeValue1(
        selectedElement?.elementValue?.split('|')[0]?.split('-')[1],
      );
      workflowConfigurationStore.setBarcodeValue2(
        selectedElement?.elementValue?.split('|')[0]?.split('-')[2],
      );
    }
    // eslint-disable-next-line
  }, [selectedElement]);
  useEffect(() => {
    if (
      selectedMetaDataElem &&
      selectedMetaDataElem.elementType === 'Barcode'
    ) {
      workflowConfigurationStore.setBarcodeType(
        selectedMetaDataElem?.elementValue?.split('|')[1],
      );
      workflowConfigurationStore.setBarcodeValue0(
        selectedMetaDataElem?.elementValue?.split('|')[0]?.split('-')[0],
      );
      workflowConfigurationStore.setBarcodeValue1(
        selectedMetaDataElem?.elementValue?.split('|')[0]?.split('-')[1],
      );
      workflowConfigurationStore.setBarcodeValue2(
        selectedMetaDataElem?.elementValue?.split('|')[0]?.split('-')[2],
      );
    }
    // eslint-disable-next-line
  }, [selectedMetaDataElem]);
  const handleInputChange = (e: any, data: any, index: number) => {
    if (index === 0) {
      workflowConfigurationStore.setBarcodeValue0(data.value);
    } else if (index === 1) {
      workflowConfigurationStore.setBarcodeValue1(data.value);
    } else {
      workflowConfigurationStore.setBarcodeValue2(data.value);
    }
  };

  const handleChange = (e: any, data: any, val: string) => {
    workflowConfigurationStore.setBarcodeType(val);
    workflowConfigurationStore.setBarcodeValue0('');
    workflowConfigurationStore.setBarcodeValue1('');
    workflowConfigurationStore.setBarcodeValue2('');
  };
  const IconData = (
    <Icon name="minus" size="small" color="black" style={iconStyle} />
  );

  return (
    <div>
      {/* <Form.Field
                id="Parent"
                options={metaDataOptions}
                control={Select}
                placeholder="Choose Parent"
                // value={validationState}
                // onChange={(e:SyntheticEvent,data:any)=>setValidationState(data.value)}
              /> */}
      <Dropdown
        text={workflowConfigurationStore.WorkflowConfiguration.barcodeType}
        fluid
        selection
        value={workflowConfigurationStore.WorkflowConfiguration.barcodeType}
        placeholder="Barcode Type"
      >
        <Dropdown.Menu style={{ width: '100%' }}>
          {barcodeOptions.map((x) => {
            return (
              <Popup
                key={x.key}
                position="top left"
                inverted
                content={x.text2}
                trigger={
                  <Dropdown.Item
                    key={x.key}
                    name={x.text}
                    text={x.text}
                    onClick={(e: any, data: any) =>
                      handleChange(e, data, x.value)
                    }
                  />
                }
              />
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
      {workflowConfigurationStore.WorkflowConfiguration.barcodeType ===
        'Code128' ||
      workflowConfigurationStore.WorkflowConfiguration.barcodeType ===
        'TelepenAlpha' ? (
        <div style={{ padding: '0.5rem 5rem' }}>
          <Header />
          <Form.Group widths="equal">
            <Form.Field
              id="form-input-control-first-name"
              control={Input}
              placeholder="ABC"
              onChange={(e: any, data: any) => handleInputChange(e, data, 0)}
              value={
                workflowConfigurationStore.WorkflowConfiguration.barcodeValue0
              }
            />
            {IconData}
            <Form.Field
              id="form-input-control-last-name"
              control={Input}
              placeholder="abc"
              onChange={(e: any, data: any) => handleInputChange(e, data, 1)}
              value={
                workflowConfigurationStore.WorkflowConfiguration.barcodeValue1
              }
            />
            {IconData}
            <Form.Field
              control={Select}
              id="form-input-control-last-name"
              type="number"
              options={
                workflowConfigurationStore.WorkflowConfiguration
                  .incrementalValues
              }
              onChange={(e: any, data: any) => handleInputChange(e, data, 2)}
              placeholder="01"
              value={
                workflowConfigurationStore.WorkflowConfiguration.barcodeValue2
              }
            />
          </Form.Group>
        </div>
      ) : null}
      {/* barcode second type */}
      {workflowConfigurationStore.WorkflowConfiguration.barcodeType ===
        'Code11' && (
        <div style={{ padding: '0.5rem 5rem' }}>
          <Header />
          <Form.Group widths="equal">
            <Form.Field
              id="form-input-control-first-name"
              control={Input}
              placeholder="1234"
              onChange={(e: any, data: any) => handleInputChange(e, data, 0)}
              value={
                workflowConfigurationStore.WorkflowConfiguration.barcodeValue0
              }
            />
            {IconData}
            <Form.Field
              id="form-input-control-last-name"
              control={Input}
              placeholder="1234"
              onChange={(e: any, data: any) => handleInputChange(e, data, 1)}
              value={
                workflowConfigurationStore.WorkflowConfiguration.barcodeValue1
              }
            />
          </Form.Group>
        </div>
      )}
      {/* barcode second type */}
      {workflowConfigurationStore.WorkflowConfiguration.barcodeType ===
        'Code25IL' && (
        <div style={{ padding: '0.5rem 5rem' }}>
          <Header />
          <Form.Group widths="equal">
            <Form.Field
              id="form-input-control-first-name"
              control={Input}
              placeholder="1234"
              onChange={(e: any, data: any) => handleInputChange(e, data, 0)}
              value={
                workflowConfigurationStore.WorkflowConfiguration.barcodeValue0
              }
            />
          </Form.Group>
        </div>
      )}
      {/* barcode second type */}
      {workflowConfigurationStore.WorkflowConfiguration.barcodeType ===
        'Code39' && (
        <div style={{ padding: '0.5rem 5rem' }}>
          <Header />
          <Form.Group widths="equal">
            <Form.Field
              id="form-input-control-first-name"
              control={Input}
              placeholder="ABC"
              onChange={(e: any, data: any) => handleInputChange(e, data, 0)}
              value={
                workflowConfigurationStore.WorkflowConfiguration.barcodeValue0
              }
            />
            {IconData}
            <Form.Field
              id="form-input-control-last-name"
              control={Select}
              options={
                workflowConfigurationStore.WorkflowConfiguration
                  .incrementalValues
              }
              placeholder="1234"
              onChange={(e: any, data: any) => handleInputChange(e, data, 1)}
              value={
                workflowConfigurationStore.WorkflowConfiguration.barcodeValue1
              }
            />
          </Form.Group>
        </div>
      )}
      {/* barcode second type */}
      {workflowConfigurationStore.WorkflowConfiguration.barcodeType ===
        'Code39FullASCII' && (
        <div style={{ padding: '0.5rem 5rem' }}>
          <Header />
          <Form.Group widths="equal">
            <Form.Field
              id="form-input-control-first-name"
              control={Input}
              placeholder="Aa"
              onChange={(e: any, data: any) => handleInputChange(e, data, 0)}
              value={
                workflowConfigurationStore.WorkflowConfiguration.barcodeValue0
              }
            />
            {IconData}
            <Form.Field
              id="form-input-control-last-name"
              control={Select}
              options={
                workflowConfigurationStore.WorkflowConfiguration
                  .incrementalValues
              }
              placeholder="1234"
              onChange={(e: any, data: any) => handleInputChange(e, data, 1)}
              value={
                workflowConfigurationStore.WorkflowConfiguration.barcodeValue1
              }
            />
          </Form.Group>
        </div>
      )}
      {/* barcode second type */}
      {workflowConfigurationStore.WorkflowConfiguration.barcodeType ===
        'Code93' && (
        <div style={{ padding: '0.5rem 5rem' }}>
          <Header />
          <Form.Group widths="equal">
            <Form.Field
              id="form-input-control-first-name"
              control={Input}
              placeholder="Aa"
              onChange={(e: any, data: any) => handleInputChange(e, data, 0)}
              value={
                workflowConfigurationStore.WorkflowConfiguration.barcodeValue0
              }
            />
            {IconData}
            <Form.Field
              id="form-input-control-last-name"
              control={Input}
              placeholder="1234"
              onChange={(e: any, data: any) => handleInputChange(e, data, 1)}
              value={
                workflowConfigurationStore.WorkflowConfiguration.barcodeValue1
              }
            />
          </Form.Group>
        </div>
      )}
      {/* barcode second type */}
      {workflowConfigurationStore.WorkflowConfiguration.barcodeType ===
        'Flattermarken' ||
      workflowConfigurationStore.WorkflowConfiguration.barcodeType === 'MSI' ? (
        <div style={{ padding: '0.5rem 5rem' }}>
          <Header />
          <Form.Group widths="equal">
            <Form.Field
              id="form-input-control-first-name"
              control={Input}
              placeholder="Aa"
              onChange={(e: any, data: any) => handleInputChange(e, data, 0)}
              value={
                workflowConfigurationStore.WorkflowConfiguration.barcodeValue0
              }
            />
          </Form.Group>
        </div>
      ) : null}
      {/* barcode second type */}
      {workflowConfigurationStore.WorkflowConfiguration.barcodeType ===
        'EANUCC128' && (
        <div style={{ padding: '0.5rem 5rem' }}>
          <Header />
          <Form.Group widths="equal">
            <Form.Field
              id="form-input-control-first-name"
              control={Input}
              placeholder="0101234567890128TEC"
              onChange={(e: any, data: any) => handleInputChange(e, data, 0)}
              value={
                workflowConfigurationStore.WorkflowConfiguration.barcodeValue0
              }
            />
            {IconData}
            <Form.Field
              id="form-input-control-last-name"
              control={Input}
              placeholder="IT"
              onChange={(e: any, data: any) => handleInputChange(e, data, 1)}
              value={
                workflowConfigurationStore.WorkflowConfiguration.barcodeValue1
              }
            />
          </Form.Group>
        </div>
      )}
      {/* Pharmacode Two-Track */}
      {workflowConfigurationStore.WorkflowConfiguration.barcodeType ===
        'OneTrackPharmacode' ||
      workflowConfigurationStore.WorkflowConfiguration.barcodeType ===
        'TwoTrackPharmacode' ? (
        <div style={{ padding: '0.5rem 5rem' }}>
          <Header />
          <Form.Group widths="equal">
            <Form.Field
              id="form-input-control-first-name"
              control={Input}
              placeholder="0123"
              onChange={(e: any, data: any) => handleInputChange(e, data, 0)}
              value={
                workflowConfigurationStore.WorkflowConfiguration.barcodeValue0
              }
            />
          </Form.Group>
        </div>
      ) : null}
    </div>
  );
}

export default observer(SettingsBarcode);
